import { ErrorResponse } from '~shared/models';
import { BrandSearchResponse } from '~app/modules/brand-plp/models';

export interface ProductsState {
  payload: BrandSearchResponse;
  loading: boolean;
  error: ErrorResponse;
  currentFilter: { [key: string]: any };
  currentOffset: number;
  currentLimit: number;
}
export const productsInitialState: ProductsState = {
  payload: {
    correction: '',
    products: {
      items: [],
      totalCount: 0,
    },
    metaData: null,
  },
  loading: false,
  error: null,
  currentFilter: {},
  currentOffset: 0,
  currentLimit: 0
};
